import { Button } from "components/atoms/button/button";
import styled from "styled-components";

export const FreeUserMobileUserNotice = styled.div`
  padding: 16px 20px;
  background: url("/assets/kelas-live/user-notice-stars.svg") right -30px bottom -30px
      no-repeat,
    ${({ theme }) => theme.colors.green[600]};
`;

export const FreeUserMobileUserNoticeMessageHeading1 = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.md};
  line-height: 1;
  margin: 0;
  color: ${({ theme }) => theme.colors.white};
`;
export const FreeUserMobileUserNoticeMessageHeading2 = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: 1;
  margin: 0;
  color: ${({ theme }) => theme.colors.white};
`;

export const FreeUserMobileUserNoticeMessage = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: 1;
  color: ${({ theme }) => theme.colors.white};
  margin: 0;
`;

export const FreeUserMobileSection = styled.section`
  background-color: ${({ theme }) => theme.colors.brand[500]};
`;
export const FreeUserMobileHeading = styled.h1`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  line-height: 1.1;
  text-align: center;
  margin: 0 0 4px 0;
  color: ${({ theme }) => theme.colors.white};
`;

export const FreeUserMobileFeatureBlock = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.brand[700]};
  padding: 16px;
  border-radius: 16px;
  gap: 16px;
`;

export const FreeUserMobileFeatureBlockImageWrapper = styled.figure`
  margin: 0;
  border-radius: 8px;
  overflow: hidden;
  width: 80px;
  height: 80px;
  position: relative;
`;

export const FreeUserMobileFeatureBlockImage = styled.img`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
`;

export const FreeUserMobileFeatureBlockDetails = styled.div``;

export const FreeUserMobileFeatureBlockHeading = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: 1;
  color: ${({ theme }) => theme.colors.white};
  margin: 0 0 8px 0;
`;

export const FreeUserMobileFeatureBlockLink = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.md};
  line-height: 1;
  color: ${({ theme }) => theme.colors.white};
  margin: 0;
`;

export const FreeUserMobileFeatureBlockCTA = styled.a`
  --webkit-appearance: none;
  background-color: ${({ theme }) => theme.colors.brand[50]};
  color: ${({ theme }) => theme.colors.brand["500"]} !important;
  font-weight: bold;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  border-radius: 4px;
  box-shadow: none;
  border: none;
  cursor: pointer;
  max-width: 160px;
  white-space: nowrap;
  text-decoration: none;
`;

export const FreeUserMobileDivider = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: 1;
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  gap: 10px;

  &:before,
  &:after {
    content: "";
    height: 2px;
    width: 100%;
    background-color: ${({ theme }) => theme.colors.white};
  }
`;

export const LiveClassMobileBannerContainer = styled.div`
  position: relative;
`;
export const FreeUserMobileContainer = styled.div`
  position: absolute;
  top: 40px;
  left: 20px;
  display: flex;
  flex-direction: column;
`;
export const FreeUserMobileHeading1 = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.xxs};
  line-height: 1;
  margin: 0 0 4px 0;
  color: ${({ theme }) => theme.colors.white};
`;
export const FreeUserMobileHeading2 = styled.p`
  width: 180px;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: 20px;
  margin: 0 0 16px 0;
  color: ${({ theme }) => theme.colors.white};
`;
export const StyledButton = styled(Button)`
  font-size: ${({ theme }) => theme.fontSizes["xs"]};
  font-family: ${({ theme }) => theme.fonts.primary};
  padding: 10px 16px;
  background-color: ${({ theme }) => theme.colors.brand[50]};
  height: 40px;
`;

export const TryLiveClassMessageContainer = styled.section`
  display: flex;
  flex-direction: column;
`;
export const TryLiveClassMessageImage = styled.div`
  padding: 40px 60px 10px;
`;
export const TryLiveClassMessageHeading = styled.h2`
  text-align: center;
  font-weight: bold;
  font-family: ${({ theme }) => theme.fonts.primary};
  line-height: 28px;
  margin: 24px 16px 16px;
`;
export const ActivateTrialButton = styled(Button)`
  margin: 0 16px;
`;
